/*#__NO_SIDE_EFFECTS__*/
const noop = (any) => any;

export { noop };
